function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v7.5l-25.333,7.333L0,7.5Z",
    style: {
      fill: "#0038a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.667,15h25.333v7.5H0l4.667-7.5Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.99,15L0,22.5V7.5l12.99,7.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.667,
    cy: 15,
    r: 1.5,
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.667,15l-.527-2.651.158-.158.175-.163.195-.195.195.195.175.163.158.158-.529,2.651Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M4.667,15l.527,2.651-.158.158-.175.163-.195.195-.195-.195-.175-.163-.158-.158.529-2.651Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M4.667,15l2.652-.527.158.158.163.175.193.194-.195.195-.163.175-.158.158-2.65-.528Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M4.667,15l-2.651.527-.158-.158-.163-.175-.195-.194.195-.195.163-.175.158-.158,2.651.528Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M4.667,15l1.502-2.248h.223l.239.009h.276v.276l.009.239v.223l-2.249,1.501Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M4.667,15l-1.502,2.248h-.223l-.239-.009h-.276v-.276l-.009-.239v-.223l2.249-1.501Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M4.667,15l2.248,1.502v.223l-.009.239v.276h-.276l-.239.009h-.223l-1.501-2.249Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M4.667,15l-2.248-1.502v-.223l.009-.239v-.276h.276l.239-.009h.223l1.501,2.249Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M11.49,15l-.564.196-.012.596-.361-.475-.571.173.341-.49-.341-.49.571.173.361-.475.012.596.564.196Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d1",
    "data-name": "d",
    d: "M.75,21.201l.112-.586-.511-.309.592-.074.136-.581.254.54.595-.05-.435.408.232.55-.523-.288-.452.39Z",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d2",
    "data-name": "d",
    d: "M.75,8.799l.452.39.523-.288-.232.55.435.408-.595-.05-.254.54-.136-.581-.592-.074.511-.309-.112-.586Z",
    style: {
      fill: "#fcd116"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/PH.76188d363d7649d53f75e2be4ad7d984.svg";
export { ForwardRef as ReactComponent };